module.exports = __webpack_public_path__ + "img/album07_24.0bf6bcac.jpg";